import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepositIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#ECEDEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.6287 13.318V13.318C27.6786 13.318 29.3404 14.9798 29.3404 17.0297V22.3471C29.3404 25.0983 27.1101 27.3286 24.3589 27.3286H15.6412C12.8899 27.3286 10.6596 25.0983 10.6596 22.3471V17.3048C10.6596 15.103 12.4446 13.318 14.6464 13.318V13.318",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_8051_25888)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M20.0001 11.8903V18.8763",
				stroke: "#4D5055",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M23.2603 16.0819L20.0001 19.342L16.74 16.0819",
				stroke: "#4D5055",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1066 22.4025H17.4309C17.7583 22.4025 18.029 22.6625 18.1724 22.9407C18.3759 23.3357 18.858 23.8036 20.0001 23.8036C21.1422 23.8036 21.6242 23.3357 21.8278 22.9407C21.9712 22.6625 22.2418 22.4025 22.5693 22.4025H28.8935",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_8051_25888",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 11.1777,
				height: 11.1777,
				fill: "white",
				transform: "translate(14.4113 11.2249)"
			})
		}) })
	]
});
export default SvgDepositIcon;
